module.exports = "/_next/static/images/waterUtilityServicesHeroSection-6ee20fea84173d0b0ffe881fb5e2b814.webp";